<script lang="ts" setup>
import PipWindow from "@/components/layout/PipWindow.vue";
import CreateCheckCallForm from "@/views/trips/components/forms/CreateCheckCallForm.vue";
import type { CheckCallDTO, CreateCheckCallRequest } from "@/api/trips/dto/check-call";
import type { RouteStopDto } from "@/api/trips/dto/trip.dto";
import type { TripMonitorRouteStop } from "@/api/trips/dto/trip-monitor";

const showDialog = defineModel<boolean>({ default: false });
const preview = defineModel<boolean>("preview", { default: false });

const props = defineProps<{
  routeId: number;
  routeStops: RouteStopDto[] | TripMonitorRouteStop[];
  creationLoading: boolean;
  checkCallPreview: CheckCallDTO | null;
  title: string;
  tripId?: number;
  isDispatchConfirmation?: boolean;
}>();

const emits = defineEmits<{
  (e: "success", checkCall: CheckCallDTO): void;
  (e: "preview", checkCall: CreateCheckCallRequest): void;
  (e: "create", checkCall: CreateCheckCallRequest): void;
}>();

function onSuccess(checkCall: CheckCallDTO) {
  emits("success", checkCall);
}

function onPreview(checkCall: CreateCheckCallRequest) {
  emits("preview", checkCall);
}

function onCreate(checkCall: CreateCheckCallRequest) {
  emits("create", checkCall);
}

function onClose() {
  showDialog.value = false;
}
</script>

<template>
  <pip-window v-model="showDialog">
    <create-check-call-form
      v-model:preview="preview"
      :check-call-preview="props.checkCallPreview"
      :creation-loading="props.creationLoading"
      :is-dispatch-confirmation="props.isDispatchConfirmation"
      :route-id="props.routeId"
      :route-stops="props.routeStops"
      :title="props.title"
      :trip-id="props.tripId"
      @close="onClose"
      @create="onCreate"
      @preview="onPreview"
      @success="onSuccess"
    >
      <template #subtitle>
        <slot name="subtitle" />
      </template>
    </create-check-call-form>
  </pip-window>
</template>

<style lang="scss" scoped></style>
